<div class="align">
  <div class="status">
    <i class="uil uil-{{ icon }} {{ color }}"></i>
    <p class="{{ color }}">{{ status }}</p>
  </div>
</div>
